/* eslint-disable react/require-default-props */
import React from 'react';
import _get from 'lodash/get';
import { Field } from 'formik';
import ControlledDatePicker, { Props as ControlledDatePickerProps } from '@minecraft.controlled-date-picker';
import { withErrorMessage, setFieldValueAndTouched } from '@minecraft.utils';

/* ------ Types ------ */
type MergedPropNames = 'value' | 'onChange' | 'onBlur'; // merged props in ControlledDatePicker

type Props = {
  name: string;
} & Omit<ControlledDatePickerProps, MergedPropNames>;

/* ------ Help Components ------ */
const DatePicker = ({ form, field, onChange, ...restProps }) => (
  <ControlledDatePicker
    value={_get(form.values, field.name)}
    onBlur={() => form.setTouched({ ...form.touched, [field.name]: true })}
    onChange={(date) => setFieldValueAndTouched(field.name, date, form)}
    {...restProps}
  />
);

/* ------ Main Component ------ */
const FormikDatePicker = (props: Props) => (
  <Field name={props.name} {...props}>
    {(fieldProps) => withErrorMessage(DatePicker)({ ...props, ...fieldProps })}
  </Field>
);

export default FormikDatePicker;
